export const REPLY_SUGGESTIONS_TIMEOUT = 30000;
export const COPILOT_MESSAGE_TIMEOUT = 60000;
